export default __webpack_public_path__ + "edd42e77272fd7e35e92aae6ab72e0c1.png";